<template>
    <div class="page-store">
        <content-item :noPadding="true">
            <div class="store-main">
                <div class="left-nav" id="left">
                    <div class="user-info">
                        <template v-if="user.accessToken">
                            <h4>{{ user.username }}<span @click="logout">[{{ $t('logout') }}]</span></h4>
                            <p>{{ $t('egPoint') }} <span>{{ totalEg }}</span></p>
                        </template>
                        <template v-else>
                          <h4 class="login"><em @click="login">{{ $t('login') }}</em>/<em @click="register">{{ $t('userRegister') }}</em></h4>
                        </template>
                    </div>
                    <div class="nav-list">
                        <router-link to="/store/recharge" active-class="nav-active">{{ $t('egRecharge') }}</router-link>
                        <router-link to="/store/consume" active-class="nav-active">{{ $t('buyGoods') }}</router-link>
                        <router-link to="/store/records/consume" active-class="nav-active">{{ $t('consumeRecords') }}
                        </router-link>
                        <router-link to="/store/records/recharge" active-class="nav-active">{{ $t('rechargeRecords') }}
                        </router-link>
                    </div>
                </div>
                <div class="right-content" id="right">
                    <router-view></router-view>
                </div>
            </div>
        </content-item>
        <login v-if="showLoginPopup"></login>
        <register v-if="showRegisterPopup"></register>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import Login from './store/Login.vue'
    import Register from './store/Register.vue'
    import Vue from 'vue'
    import {USER_LOGOUT} from '../store/mutation-types'
    import ContentItem from './partial/ContentItem.vue'

    export default {
        computed: {
            ...mapState([
                'user',
                'showLoginPopup',
                'showRegisterPopup',
                'totalEg'
            ])
        },
        components: {
            Login,
            ContentItem,
            Register
        },
        methods: {
            logout() {
                this.$router.replace({path: '/store'});
                this.$store.dispatch([USER_LOGOUT]);
            },
            login() {
                this.$store.commit('controlLoginPopup', true);
            },
            register() {
                this.$store.commit('controlRegisterPopup', true);
            }
        },
        created() {
            if (this.user && this.user.uid) {
                this.$store.commit('getTotalEg');
            }
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../assets/scss/lib.scss";

    .page-store {
        width: 100%;
        margin: 50px auto 0;
    }

    .store-main {
        @include flex;
        @include cross-stretch;
        @include main-justify;
        position: relative;
    }

    .left-nav {
        @include flex;
        @include dir-top;
        @include cross-bottom;
        width: 210px;
        @include flex-grow(0);
        background: #f1f1f1;
        margin: 5px;
        .user-info {
            height: 100px;
            width: 210px;
            border-bottom: 2px dashed #d5d5d5;
            border-radius: 5px;
            text-align: center;
            padding: 10px 5px;
            @include flex-column-center;
            box-sizing: border-box;
            h4 {
                span {
                    font-size: 80%;
                    color: $blue-color;
                    margin-left: 10px;
                    cursor: pointer;
                    text-decoration: none;
                }
                em{
                    font-style: inherit;
                    font-weight: 400;
                    text-decoration: underline;
                }
            }
            p {
                margin-top: 5px;
                span {
                    color: $blue-color;
                }
            }
            .login {
                font-size: 20px;
                color: $blue-color;
                &:hover {
                    cursor: pointer;
                }
            }
        }
        .nav-list {
            margin: 20px 0 50px;
            width: 210px;
            height: 280px;
            @include flex-space-between;
            @include dir-top;
            a {
                width: 100%;
                height: 70px;
                font-size: 17px;
                white-space: normal;
                word-break: break-all;
                color: $blue-color;
                text-decoration: none;
                box-sizing: border-box;
                @include flex-row-center;
                overflow: hidden;
            }
        }

        .nav-active {
            background: #fff;
            border-top: 1px solid #d5d5d5;
            border-bottom: 1px solid #d5d5d5;
            border-left: 8px solid $blue-color;
            margin-left: -14px;
            width: 225px !important;
            box-shadow: -3px 0px 4px 0px rgba(0, 0, 0, 0.2);
        }
    }

    .right-content {
        @include flex-grow(1);
        padding: 40px;
        @include flex;
        @include main-center;
        @include cross-top;
        min-height: 780px;
    }


</style>



// WEBPACK FOOTER //
// Store.vue?286bb05f